import { BadgeCheck, ShieldCheck, Truck } from "lucide-react";
import { WhatsAppIcon } from "../Logo";
import { waLink } from "../../api";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1715613814847-a124f06fcf3a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHx2YXBlJTIwcG9kJTIwZGlzcG9zYWJsZSUyMGRldmljZSUyMGVsZWN0cm9uaWMlMjBjaWdhcmV0dGUlMjBwcm9kdWN0fGVufDB8fHx8MTc4OTA4OTIzOXww&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="relative overflow-hidden bg-[radial-gradient(ellipse_80%_80%_at_50%_-20%,rgba(124,92,255,0.18),rgba(22,24,29,0))] px-4 pt-32 pb-20 lg:pt-40 lg:pb-28"
    >
      <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-2">
        <div className="animate-fade-up">
          <div className="mb-6 flex flex-wrap gap-2">
            <span className="rounded-full border border-[#2EE6D6]/30 bg-[#2EE6D6]/10 px-3 py-1 text-xs font-semibold text-[#2EE6D6]">
              Envío 24/48h
            </span>
            <span className="rounded-full border border-[#7C5CFF]/30 bg-[#7C5CFF]/10 px-3 py-1 text-xs font-semibold text-[#7C5CFF]">
              Hasta 100.000 caladas
            </span>
            <span className="rounded-full border border-[#2D323E] px-3 py-1 text-xs font-semibold text-[#8A8F98]">
              Solo +18
            </span>
          </div>
          <h1 className="font-heading text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl">
            Vapers desechables premium,{" "}
            <span className="text-gradient">al mejor precio de España</span>
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-[#8A8F98] sm:text-lg">
            Los modelos más potentes del mercado — Razz Bar, Bang, Happ Bar, Rock Me y más — con
            hasta un 50% de descuento. Pide en un minuto por WhatsApp y recíbelo en 24/48h.
          </p>
          <div className="mt-9 flex flex-col gap-4 sm:flex-row">
            <a
              href={waLink("Hola NubeVape España, quiero hacer un pedido. ¿Me ayudáis a elegir?")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-whatsapp-btn"
              className="flex items-center justify-center gap-3 rounded-full bg-[#25D366] px-8 py-4 text-base font-bold text-black shadow-[0_4px_20px_rgba(37,211,102,0.35)] transition-all hover:bg-[#20BA5A] hover:shadow-[0_8px_28px_rgba(37,211,102,0.5)]"
            >
              <WhatsAppIcon className="h-5 w-5" />
              Pedir por WhatsApp
            </a>
            <a
              href="#catalogo"
              data-testid="hero-catalog-btn"
              className="flex items-center justify-center rounded-full border border-[#2D323E] px-8 py-4 text-base font-semibold text-[#F2F4F6] transition-colors hover:border-[#2EE6D6]/60 hover:text-[#2EE6D6]"
            >
              Ver catálogo
            </a>
          </div>
          <div className="mt-10 flex flex-wrap gap-6 text-sm text-[#8A8F98]">
            <span className="flex items-center gap-2">
              <Truck className="h-4 w-4 text-[#2EE6D6]" /> Envíos rápidos
            </span>
            <span className="flex items-center gap-2">
              <BadgeCheck className="h-4 w-4 text-[#2EE6D6]" /> Producto original
            </span>
            <span className="flex items-center gap-2">
              <ShieldCheck className="h-4 w-4 text-[#2EE6D6]" /> Pago flexible
            </span>
          </div>
        </div>
        <div className="relative hidden lg:block">
          <div className="animate-float-slow overflow-hidden rounded-3xl border border-[#2D323E] shadow-[0_30px_80px_-20px_rgba(124,92,255,0.35)]">
            <img
              src={HERO_IMAGE}
              alt="Vaper desechable premium"
              className="h-[480px] w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#16181D]/70 via-transparent to-transparent" />
          </div>
          <div className="absolute -bottom-5 left-8 rounded-2xl border border-[#2D323E] bg-[#1E2128]/90 px-5 py-3 backdrop-blur-xl">
            <p className="text-xs uppercase tracking-widest text-[#8A8F98]">Desde</p>
            <p className="font-heading text-2xl font-extrabold text-gradient">6,49€</p>
          </div>
        </div>
      </div>
    </section>
  );
}
